// extracted by css-extract-rspack-plugin
export default {"SidebarView":"SummarizeSidebar-module__SidebarView___wyDnZ"};